import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Modal, ContactCard, Button } from 'hosman-material';
import { S_Pen, S_TrashCan, S_Info } from 'hosman-material';

import { updateSalesUser, updateSalesUserToRemove, removeSalesUser, getSalesUsers } from '../../../../../../../../../../reducers/SellerApp/salesUsersSlice';

const Signatories = () => {
  const { sale } = useSelector((state) => state.sellerSales);
  const { signatories, isRemoving, salesUserToRemove } = useSelector((state) => state.sellerSalesUsers);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSalesUsers(sale.id));
  }, []);

  const handleUpdate = (signatory) => {
    dispatch(updateSalesUser({
      id: signatory.id,
      kind: signatory.kind,
      signatory: signatory.signatory,
      user_id: signatory.user.id,
      active: signatory.user.active,
      first_name: signatory.user.first_name,
      last_name: signatory.user.last_name,
      civility: signatory.user.civility,
      email: signatory.user.email,
      phone_country_code: signatory.user.phone_country_code || 'FR',
      phone_number: signatory.user.phone_number
    }))
  }  

  return (
    <div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
      {signatories.map((signatory, index) => {
        return (
          <div key={signatory.id} className='relative w-min'>
            <ContactCard
              email={signatory.user.email}
              name={`${signatory.user.first_name} ${signatory.user.last_name}`}
              phone={signatory.user.phone_number.replace('+33', '0')}
              title={`Signataire ${index + 1} ${signatory.user.type === 'owner' ? '(vous)' : ''}`}
            />

            {signatory.kind !== 'owner' &&
              <div className='absolute top-12 right-0 md:-top-3 md:right-3 flex flex-col md:flex-row gap-2'>
                <div className='flex items-center justify-center border bg-ih-purple-10 text-ih-indigo w-12 h-12 md:w-8 md:h-8 rounded-full cursor-pointer'>
                  <FontAwesomeIcon icon={S_Pen} onClick={() => handleUpdate(signatory)} />
                </div>

                <div className='flex items-center justify-center border bg-ih-red-10 text-ih-red-80 w-12 h-12 md:w-8 md:h-8 rounded-full cursor-pointer'>
                  <FontAwesomeIcon icon={S_TrashCan} onClick={() => dispatch(updateSalesUserToRemove(signatory))} />
                </div>
              </div>
            }
          </div>
        )
      })}

      {salesUserToRemove &&
        <Modal isOpen closeModal={() => dispatch(updateSalesUserToRemove(null))}>
          <div className='flex flex-col items-center gap-6 p-8'>
            <div className='flex items-center justify-center bg-ih-red-20 text-ih-red-80 w-8 h-8 rounded-full'>
              <FontAwesomeIcon icon={S_Info} />
            </div>

            <p className='h3 text-ih-indigo'>Êtes-vous sûr de vouloir supprimer le signataire {salesUserToRemove.user.first_name} {salesUserToRemove.user.last_name} ?</p>
            
            <div className='flex flex-col md:flex-row md:justify-center gap-3'>
              <Button label='Annuler' type='tertiary' onClick={() => dispatch(updateSalesUserToRemove(null))} />
              <Button label='Confirmer' onClick={()  => dispatch(removeSalesUser({ saleId: sale.id, salesUserId: salesUserToRemove.id }))} isLoading={isRemoving} />
            </div>
          </div>
        </Modal>
      }
    </div>
  );
}

export default Signatories;
